import React, { useState, useCallback, useRef } from "react";
import cx from "classnames";
import { Icon, useOnClickOutside, color } from "@wf/components";
import styles from "./UserBar.module.scss";

interface UserBarProps {
  username?: string;
  isAuthenticated?: boolean;
  handleLogin: () => void;
  handleLogout: () => void;
  handleViewProfile: () => void;
  translate?: (text: string) => string;
  createAccountLink?: string | null;
  className?: string;
}

const UserBar: React.FC<UserBarProps> = ({
  isAuthenticated,
  username,
  handleLogin,
  handleLogout,
  handleViewProfile,
  createAccountLink,
  translate = (text) => text,
  className,
  ...rest
}) => {
  const refContainer = useRef(null);
  const [isDropDownOpened, setIsDropDownOpened] = useState(false);

  const toggleProfile = useCallback(() => {
    setIsDropDownOpened(state => !state);
  }, []);

  useOnClickOutside(
    { current: refContainer.current },
    () => {
      setIsDropDownOpened(false);
    },
    { ignoreClassNames: [styles.list] }
  );

  return (
    <div className={cx(styles.userBar, className)} {...rest} ref={refContainer}>
      {isAuthenticated ? (
        <>
          <span onClick={toggleProfile} className={styles.currentUser}>
            {username}
            <Icon className={styles.arrow} name={isDropDownOpened ? "ic_arrow_up" : "ic_arrow_down"} size={10} />
          </span>
          {isDropDownOpened && (
            <ul className={styles.profileDropdown}>
              <li onClick={handleViewProfile}>
                <Icon className={styles.icon} name="ic_profile" color={color("typography", "light")} />
                <span>{translate("View Account")}</span>
              </li>
              <li onClick={handleLogout}>
                <Icon className={styles.icon} name="ic_logout" color={color("typography", "light")} />
                <span>{translate("Log Out")}</span>
              </li>
            </ul>
          )}
        </>
      ) : (
        <span onClick={handleLogin} className={styles.profileBtn}>
          {translate("Log In")}
        </span>
      )}
      {createAccountLink && !isAuthenticated && (
        <a href={createAccountLink} className={styles.createAccountLink}>
          {translate("Sign Up")}
        </a>
      )}
    </div>
  );
};
export default UserBar;
